function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 2,
  fill: "#FDFDFD"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 19,
  width: 14,
  height: 4,
  transform: "rotate(-90 7 19)",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 19,
  width: 14,
  height: 4,
  transform: "rotate(-90 13 19)",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4 3V21",
  stroke: "black",
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20 3V21",
  stroke: "black",
  strokeLinecap: "round"
});

function SvgJustifyEvenly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustifyEvenly);
export default __webpack_public_path__ + "static/media/justify-evenly.881b2410.svg";
export { ForwardRef as ReactComponent };